import ZkAuthTree from './src/main'
ZkAuthTree.install = function (Vue) {
  Vue.component(ZkAuthTree.name, ZkAuthTree)
}
export default ZkAuthTree



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/authTree/index.js